import { Form, Row } from 'antd';
import Box from 'components/Box';
import SwitchV2 from 'components/SwitchV2';
import Text from 'components/Text';
import styled from 'styled-components';

interface FieldItemProps {
  name: string;
  label: string;
  description?: string;
  icon?: React.ReactNode;
  bgColor?: string;
}

const FieldItem = ({ name, label, description, icon, bgColor }: FieldItemProps) => {
  return (
    <FieldRow>
      <Box display='flex' flexDirection='row' alignItems='center'>
        {icon && <BoxIcon bgColor={bgColor}>{icon}</BoxIcon>}
        <Box display='flex' flexDirection='column'>
          <Text variant='H7'>{label}</Text>
          {description && <Text variant='CONTENT_1'>{description}</Text>}
        </Box>
      </Box>

      <Form.Item name={name} valuePropName='checked' noStyle>
        <SwitchV2 />
      </Form.Item>
    </FieldRow>
  );
};

export default FieldItem;

const FieldRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 24px;
  border: 1px solid #e9edf2;
  border-radius: 8px;
  background: #fff;
  font-family: Poppins;

  .ant-switch {
    zoom: 1.5;
  }
`;

const BoxIcon = styled.div<{ bgColor?: string }>`
  width: 40px;
  height: 40px;
  border-radius: 100px;
  background: ${({ bgColor }) => bgColor || '#CBD5E1'};
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 12px;
`;
